import { ComponentProps } from "react";
import { ComputeFieldComponent } from "../computeFields";
import { MultipleprintInExhibition } from "../types";
import { SeparatedList } from "./shared/utils";

export const ExhibitionMultipleprintDescriptionCF: ComputeFieldComponent<
  Pick<
    MultipleprintInExhibition,
    | "exhibition"
    | "expositionsDansEstampesMultiplesDescriptionExemplaireExpose"
    | "expositionsDansEstampesMultiplesDescriptionNumero"
  >
> = ({ input, language, translation, ...props }) => {
  const t = translation ?? (() => "");
  return (
    <SeparatedList
      {...props}
      lineBreak={false}
      language={language}
      commaSeparated
      input={[
        <span
          key={1}
          dangerouslySetInnerHTML={{
            __html: input.exhibition?.expositionsDescriptionResume ?? "",
          }}
        />,
        input.expositionsDansEstampesMultiplesDescriptionExemplaireExpose && (
          <>
            {t("computeField.numeroExemplaireExpose")}{" "}
            {input.expositionsDansEstampesMultiplesDescriptionExemplaireExpose}
          </>
        ),
        input.expositionsDansEstampesMultiplesDescriptionNumero && (
          <>
            {t("computeField.numeroCatalogueAbbrege")}{" "}
            {input.expositionsDansEstampesMultiplesDescriptionNumero}
          </>
        ),
      ]}
    />
  );
};

export const RelatedExhibitionsMultipleprintCF: ComputeFieldComponent<{
  relatedExhibitions?: ComponentProps<
    typeof ExhibitionMultipleprintDescriptionCF
  >["input"][];
}> = ({ input, lineBreak = true, ...props }) => {
  if (!input.relatedExhibitions || input.relatedExhibitions.length === 0) {
    return <></>;
  }
  return (
    <SeparatedList
      {...props}
      input={input.relatedExhibitions.map((item) => (
        <ExhibitionMultipleprintDescriptionCF
          input={item}
          lineBreak={lineBreak}
          {...props}
        />
      ))}
      lineBreak={lineBreak}
    />
  );
};
